import {
  loadingPaletteColors,
  elementsTransition,
  getSelectedGamePackPalette
} from '@/utils/gamePacks';
import BottomDynamicShape from './BackgroundElements/BottomDynamicShape';
import BottomLineElement from './BackgroundElements/BottomLineElement';
import InverseDynamicShape from './BackgroundElements/InverseDynamicShape';
import LeftFixedShape from './BackgroundElements/LeftFixedShape';
import RightDynamicShape from './BackgroundElements/RightDynamicShape';
import { GamePackPalette } from '@/API';
import clsx from 'clsx';

export default function Background({
  gamepackPalette,
  updateKey,
  loading
}: {
  gamepackPalette: GamePackPalette;
  updateKey: string;
  loading: boolean;
}) {
  const palette = getSelectedGamePackPalette(gamepackPalette);

  return (
    <div
      className={clsx(
        'h-full w-full absolute z-0 overflow-hidden',
        loading ? loadingPaletteColors.bg : palette?.colors.bg
      )}
      key={updateKey}
    >
      <LeftFixedShape
        className="absolute top-135 left-0 origin-left"
        color={loading ? loadingPaletteColors.inverse : ''}
        initial={loading ? { scale: 1 } : { scale: 0.5 }}
        animate={{ scale: 1 }}
        transition={elementsTransition}
      />
      <RightDynamicShape
        className="absolute bottom-0 right-0 origin-bottom-right"
        color={loading ? loadingPaletteColors.shapes : palette?.colors.shapes}
        initial={loading ? { scale: 1 } : { scale: 0.5 }}
        animate={{ scale: 1 }}
        transition={elementsTransition}
      />
      <InverseDynamicShape
        className="absolute bottom-0 right-0 origin-bottom-left"
        color={loading ? loadingPaletteColors.inverse : palette?.colors.inverse}
        initial={loading ? { scale: 1 } : { scale: 0.5 }}
        animate={{ scale: 1 }}
        transition={elementsTransition}
      />
      <BottomDynamicShape
        className="absolute bottom-0 left-0 origin-bottom-right"
        color={loading ? loadingPaletteColors.shapes : palette?.colors.shapes}
        initial={loading ? { scale: 1 } : { scale: 0.5 }}
        animate={{ scale: 1 }}
        transition={elementsTransition}
      />
      <BottomLineElement
        className="absolute bottom-0 left-400 origin-bottom-left"
        initial={loading ? { scale: 1 } : { scale: 0.5 }}
        animate={{ scale: 1 }}
        transition={elementsTransition}
      />
    </div>
  );
}
